import { Box, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import coverImage from "../../../media/images/headCover.svg";
import logoSecondary from "../../../media/images/icons/logoSecondary.svg";
import AuthFooter from "../../layout/AuthLayout/Footer";
import MobileHeader from "../../layout/AuthLayout/MobileHeader";

export default function AboutUs() {
  const divRef = useRef<HTMLDivElement>(null);
  const [hasScroll, setHasScroll] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (divRef.current && divRef.current.scrollTop > 5) {
        // Do something when scrolled more than 20 pixels
        setHasScroll(true);
      } else {
        setHasScroll(false);
      }
    };

    if (divRef.current) {
      divRef.current.addEventListener("scroll", handleScroll);
    }

    return () => {
      // Cleanup: remove the event listener when the component unmounts
      if (divRef.current) {
        divRef.current.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);
  return (
    <>
      <MobileHeader title="درباره ما" hasScroll={hasScroll} />

      <Box
        ref={divRef}
        sx={{
          // minWidth: "480px",
          maxWidth: "600px",
          width: {
            xs: "100%",
          },
          // border: "1px solid gray",
          marginX: "auto",
          flex: 1,
          display: "flex",
          overflowY: "auto",
          flexDirection: "column",
          paddingX: "8px",
          paddingY: "16px",
          gap: "12px",
        }}
      >
        <Box
          sx={{
            backgroundImage: `
          linear-gradient(0deg, rgba(211, 134, 39, 0.97) 46.43%, rgba(239, 183, 114, 0.81) 135.27%),
            url(${coverImage})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center",
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            borderRadius: "20px",
            alignItems: "center",
            justifyContent: "center",
            paddingX: "16px",
            boxShadow: "0px 4px 6px 0px rgba(0, 0, 0, 0.20)",
          }}
        >
          <Typography
            sx={{
              marginTop: "32px",
              fontSize: "22px",
              fontWeight: "900",
              color: "background.default",
            }}
          >
            درباره بازارگاه کارن ترابرنت{" "}
          </Typography>
          <Typography
            sx={{
              marginBottom: "32px",
              color: "background.default",
            }}
          >
            تاریخچه ، اهداف، افتخارات و اعضا{" "}
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "10px",
          }}
        >
          <img src={logoSecondary} alt="" />
          <Typography
            sx={{
              fontSize: "32px",
              fontWeight: "bolder",
              color: "secondary.dark",
            }}
          >
            درباره ما
          </Typography>

          <Typography
            sx={{
              color: "textColor.main",
              fontWeight: 600,
            }}
            variant="body1"
          >
            شرکت حمل و نقل "کارن ترابر خلیج فارس" پس از سالیان متوالی فعالیت
            مستمر و مفید در حوزه حمل و نقل جاده ای، با بهره گیری از زیرساخت های
            فناوری اطلاعات تصمیم بر ایجاد یک "اپلیکیشن بازارگاه اینترنتی حمل‏‌ و
            ‏نقل کالا" جهت سرویس دهی و خدمات برخط به صاحبان کالا و...
          </Typography>

          <Box
            sx={{
              width: "100%",
              // border: "1px solid gray",
              display: "flex",
              flexDirection: "column",
              textAlign: "right",
              gap: "20px",
            }}
          >
            <Typography
              variant="h1"
              sx={{
                color: "secondary.dark",
                marginTop: "16px",
                textAlign: "right",
              }}
            >
              بازارگاه کارن ترابرنت
            </Typography>
            <Typography
              sx={{
                color: "textColor.main",
                fontWeight: 600,
              }}
            >
              به منظور شفاف سازی نقش بازارگاه ها و تبیین جایگاه آن ها در بازار
              حمل و نقل جاده ای کشور که زمینه تصمیم گیری بهتر سایر عوامل فعال
              مانند شرکت های حمل و نقل را جهت همکاری یا رقابت با آن ها روشن می
              سازد، جدول دسته بندی تهیه گردید.
            </Typography>
            <Typography
              sx={{
                color: "textColor.main",
              }}
              variant="h2"
            >
              دسته اول بازارگاه:
            </Typography>
            <Typography
              sx={{
                color: "textColor.main",
              }}
              variant="body1"
            >
              محور سرویس بازارگاه ارائه خدمات به شرکت های حمل و نقل است که در
              این دسته حفظ جایگاه شرکت های حملو نقل مهم و کلیدی است. (B2B
              Marketplace)
            </Typography>
            <Typography
              sx={{
                color: "textColor.main",
              }}
              variant="h2"
            >
              دسته دوم بازارگاه:{" "}
            </Typography>
            <Typography
              sx={{
                color: "textColor.main",
              }}
              variant="body1"
            >
              آن هایی هستند که کارکرد ارائه خدمات لجستیکی مبتنی بر بستر بازارگاه
              الکترونیکی را دارند و تمرکز خدمات آن ها بر خدمات لجستیکی به صاحبان
              کالا است
            </Typography>
          </Box>
        </Box>
        <AuthFooter />
      </Box>
    </>
  );
}
